import { atom } from "jotai";

export const screenWidthAtom = atom<number>(window.innerWidth);

export const screenWidthListenerAtom = atom(null, (get, set) => {
  let timeoutId: ReturnType<typeof setTimeout> | null = null;

  const debouncedUpdateScreenWidth = () => {
    if (timeoutId) clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      set(screenWidthAtom, window.innerWidth);
    }, 50);
  };

  window.addEventListener("resize", debouncedUpdateScreenWidth);

  return () => {
    window.removeEventListener("resize", debouncedUpdateScreenWidth);
    if (timeoutId) clearTimeout(timeoutId);
  };
});
